import { render } from "./ResumeBio.vue?vue&type=template&id=5ec363a2&scoped=true"
import script from "./ResumeBio.vue?vue&type=script&lang=js"
export * from "./ResumeBio.vue?vue&type=script&lang=js"

import "./ResumeBio.vue?vue&type=style&index=0&id=5ec363a2&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec363a2"]])

export default __exports__